import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocVisibility = async ({ docId, statusId }) => {
  return await request.put(
    `/Docs/status/${docId}?statusId=${statusId}`,
    null,
    'При изменении статуса документа произошла ошибка',
    'Error'
  );
};

const useChangeDocStatus = () => {
  const mutation = useMutation(changeDocVisibility, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocStatus: mutation.isLoading,
    changeDocStatus: mutation.mutateAsync,
  };
};

export default useChangeDocStatus;
